<template>
    <div class="pb-3 text-sm font-medium text-gray-370 dark:text-white">
        Choose your billing type
    </div>

    <div class="grid max-mob:grid-cols-1 grid-cols-2 gap-x-5 gap-y-4">
        <div
            class="p-3 hover:bg-white-300 dark:bg-blue-780 border hover:border-primary dark:hover:border-gray-190 rounded-1.25 cursor-pointer transition-colors"
            :class="[
                billingType === BILLING_TYPE.INDIVIDUAL ? 'bg-white-300 border-primary dark:border-gray-190' : 'border-gray-100 dark:border-gray-730',
            ]"
            @click="selectType(BILLING_TYPE.INDIVIDUAL)"
        >
            <UserIcon24x24 class="text-primary dark:text-gray-190" />

            <div class="pt-3 pb-1 text-xs font-medium text-gray-370 dark:text-white">
                Individual
            </div>

            <div class="text-xxs text-gray-280 dark:text-gray-190">
                For personal use. Requires <br class="max-mob:hidden" /> full name and address
            </div>
        </div>

        <div
            class="p-3 hover:bg-white-300 dark:bg-blue-780 border hover:border-primary dark:hover:border-gray-190 rounded-1.25 cursor-pointer transition-colors"
            :class="[
                billingType === BILLING_TYPE.BUSINESS ? 'bg-white-300 border-primary dark:border-gray-190' : 'border-gray-100 dark:border-gray-730',
            ]"
            @click="selectType(BILLING_TYPE.BUSINESS)"
        >
            <WorkIcon24x24 class="text-primary dark:text-gray-190" />

            <div class="pt-3 pb-1 text-xs font-medium text-gray-370 dark:text-white">
                Company
            </div>

            <div class="text-xxs text-gray-280 dark:text-gray-190">
                For business accounts. Requires <br class="max-mob:hidden" /> legal company info and VAT
            </div>
        </div>
    </div>

    <div
        class="w-full mt-7 pt-4 flex gap-x-5 border-t border-gray-100 dark:border-blue-720"
        :class="isAccountTrialEnded ? 'justify-between' : 'justify-end'"
    >
        <LogoutButton v-if="isAccountTrialEnded" />

        <PrimaryBtn
            :class="{ 'max-mob:w-full': !isAccountTrialEnded }"
            :loading="loading"
            @click="nextStep"
        >
            Next
        </PrimaryBtn>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import WorkIcon24x24 from '@/components/icons/work/WorkIcon24x24.vue'
import UserIcon24x24 from '@/components/icons/user/UserIcon24x24.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

import { VERIFICATION_STEPS, BILLING_TYPE } from '@/constants/verification'
import LogoutButton from '@/components/buttons/LogoutButton.vue'

const emits = defineEmits(['nextStep', 'prevStep'])

const authorizationStore = useAuthorizationStore()
const verificationUserStore = useVerificationUserStore()

const loading = ref(false)

const isAccountTrialEnded = computed(() => authorizationStore.isAccountTrialEnded)

const billingType = computed({
    get() {
        return verificationUserStore.billingStepFormData.billing_type_id
    },
    set(value) {
        verificationUserStore.setBillingFormData({
            billing_type_id: value,
        })
    },
})

function selectType(type) {
    billingType.value = type
}

async function nextStep() {
    loading.value = true

    const { success } = await verificationUserStore.updateVerificationDataBilling()

    if (success) {
        emits('nextStep', VERIFICATION_STEPS.kyc.id)
    }

    loading.value = false
}
</script>
